__webpack_require__.p = "https://explicit-logic.github.io/p2p/";